import { render } from "./ModalSaveDraftSuccess.vue?vue&type=template&id=6da08360&scoped=true"
import script from "./ModalSaveDraftSuccess.vue?vue&type=script&lang=js"
export * from "./ModalSaveDraftSuccess.vue?vue&type=script&lang=js"

import "./ModalSaveDraftSuccess.vue?vue&type=style&index=0&id=6da08360&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6da08360"]])

export default __exports__